module.exports = __webpack_public_path__ + "static/media/success.fe142956.svg";